import { FormQuestionCodeEnum } from 'src/app/models/enums/form-question-code-enum';
import { StatementAnswerEnum, StatementBooleanAnswerEnum } from 'src/app/models/enums/statement-answer-enum';
import { StatementFormType } from 'src/app/models/enums/statement-form-type-enum';
import { WorkerFormStatementDto } from 'src/app/models/worker-form-statement-dto';

export const statementsToPpkCheck: string[] = [
  FormQuestionCodeEnum.PPK,
  FormQuestionCodeEnum.Student,
  FormQuestionCodeEnum.EmploymentContract,
  FormQuestionCodeEnum.MandateContract
];

export const ppkRelatedQuestionCodes: string[] = [...statementsToPpkCheck, FormQuestionCodeEnum.SocialSecurityContributionAmount];

export const holidayChildCareQuestionCodes: string[] = [FormQuestionCodeEnum.IsHolidayChildcare, FormQuestionCodeEnum.HolidayChildcare];

export const foreignWorkerQuestionCodes: string[] = [
  FormQuestionCodeEnum.IsForeigner,
  FormQuestionCodeEnum.FutureInPoland,
  FormQuestionCodeEnum.ResidentRP183DaysOfTaxYear
];

export const isPit2Statement = (statement: WorkerFormStatementDto): boolean => statement.StatementFormTypeId === StatementFormType.Pit2;

export const hasQuestionCode = (codes: string[]) => (statement: WorkerFormStatementDto): boolean => codes.includes(statement.QuestionCode);

export function getAnswerCodeByQuestionCode(statements: WorkerFormStatementDto[], code: string) {
  const predicate = (statement: WorkerFormStatementDto) => statement.QuestionCode === code;
  return statements.some(predicate) ? statements.find(predicate)?.Answers?.find(_ => true)?.AnswerCode : null;
}

export function checkStatementsConflicts(statements: WorkerFormStatementDto[]): boolean {
  return statements.filter(s => statementsToPpkCheck.includes(s.QuestionCode)).every(s => s.Answers.find((_) => true)?.AnswerCode == StatementBooleanAnswerEnum.NO) &&
    statements.filter(s => s.QuestionCode === FormQuestionCodeEnum.SocialSecurityContributionAmount).every(s => s.Answers.find((_) => true)?.AnswerCode != StatementAnswerEnum.SIXTYPERCENT);
}

export function hasStatementFormTypeChanged(
  savedStatements: WorkerFormStatementDto[],
  currentStatements: WorkerFormStatementDto[],
  statementFormType: StatementFormType,
): boolean {
  const getCompareObject = (workerFormStatement: WorkerFormStatementDto) => ({
    questionId: workerFormStatement.QuestionId,
    text: workerFormStatement.Text,
    answers: workerFormStatement.Answers?.sort((left, right) => left.AnswerId - right.AnswerId),
    files: workerFormStatement.Files?.sort((left, right) => left.WorkerFileId - right.WorkerFileId)
  });

  const origin = savedStatements.filter(ws => ws.StatementFormTypeId === statementFormType).map(ws => getCompareObject(ws)).sort((left, right) => left.questionId - right.questionId);
  const current = currentStatements.filter(ws => ws.StatementFormTypeId === statementFormType).map(ws => getCompareObject(ws)).sort((left, right) => left.questionId - right.questionId);

  return origin.length !== current.length || JSON.stringify(origin) !== JSON.stringify(current);
}

/**
 * Returns the saved statements with the statements matching `isInScope` replaced by their current state.
 * Used after a document for that scope was signed, so the same document is not offered again.
 */
export function markStatementsAsSaved(
  savedStatements: WorkerFormStatementDto[],
  currentStatements: WorkerFormStatementDto[],
  isInScope: (statement: WorkerFormStatementDto) => boolean,
): WorkerFormStatementDto[] {
  return [...savedStatements.filter(s => !isInScope(s)), ...currentStatements.filter(isInScope)];
}
